<template>
  <PracticeBullets :practices="records">
    <template #title>
      Dauerhaft angewandt
    </template>
    <template #empty>
      Du hast noch keine dauerhaft angewandten Methoden.
    </template>
  </PracticeBullets>
</template>

<script setup>
import { computed, watch, ref, onMounted } from 'vue';
import { useFetchResources } from '@/client/actions';

const props = defineProps({podcast: Object});
const parent = computed(() => props.podcast.id);
const target = computed(() => '/api/podcasts/' + parent.value + '/applications');
const records = computed(() => results.value.map(r => r.practice));
const action = useFetchResources(target);

const { results, fetching, fetch, empty } = action;

const mounted = onMounted(() => fetch());
const watcher = watch(target, (v, _) => fetch());
</script>
